import { Cookies } from 'react-cookie'

export default function usuarioLogado() {
  return localStorage.getItem('USUARIO') !== null
}

export function salvarLocalStorage(key, value) {
  localStorage.setItem(key, value)
}

export function apagarLocalStorage(key) {
  localStorage.removeItem(key)
}

export function obterDadosLocalStorage(key) {
  return localStorage.getItem(key)
}

export function salvarCookies(usuarioAceitou) {
  const cookie = new Cookies()
  const dataExpiracao = new Date()
  dataExpiracao.setFullYear(dataExpiracao.getFullYear() + 1)
  cookie.set('dfDataCookiesAceito', new Date().toJSON(), { path: '/', expires: dataExpiracao })
  usuarioAceitou(true)
}

export async function fazerLogoff(firebase, hist) {
  firebase.auth().signOut()
  apagarLocalStorage('USUARIO')
  apagarLocalStorage('NOME')
  apagarLocalStorage('FOTO')
  hist.push('/login')
}
